// extracted by mini-css-extract-plugin
export default {"AddNewGoalPop":"addForm_AddNewGoalPop__JyncI","modalBody":"addForm_modalBody__DDxkx","formControl":"addForm_formControl__3+CW8","add":"addForm_add__Cjj3s"};